import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

const master = {
  get(config) {
    return axiosInstance.get('/master/rob/rob', {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
  create(data) {
    return axiosInstance.post('/master/rob/rob', data, {
      cancelToken: getNewCancelToken(),
    });
  },
  delete(id, config) {
    return axiosInstance.delete(`/master/rob/rob/${id}`, {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
  update(id, data, config) {
    return axiosInstance.put(`/master/rob/rob/${id}`, data, {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
};

const summary = {
  get(mrobId, config) {
    return axiosInstance.get(`/summary/rob/${mrobId}`, {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
};

const adjustment = {
  get(config) {
    return axiosInstance.get('/master/rob/adjustment', {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
  create(data) {
    return axiosInstance.post('/master/rob/adjustment', data, {
      cancelToken: getNewCancelToken(),
    });
  },
  delete(id, config) {
    return axiosInstance.delete(`/master/rob/adjustment/${id}`, {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
  update(id, data, config) {
    return axiosInstance.put(`/master/rob/adjustment/${id}`, data, {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
};

export default {
  master,
  summary,
  adjustment,
};
